import { render, staticRenderFns } from "./ProductBundleBuilder.vue?vue&type=template&id=3619c71a&scoped=true&"
import script from "./ProductBundleBuilder.vue?vue&type=script&lang=js&"
export * from "./ProductBundleBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3619c71a",
  null
  
)

export default component.exports